export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.019 3.125A1 1 0 0116.5 4v16a1 1 0 01-1.481.876l-10-5.5A1 1 0 014.5 14.5v-5a1 1 0 01.519-.876l10-5.5zM6.5 10.09v3.819l8 4.4V5.69l-8 4.4z\" fill=\"#7B61FF\"/><path d=\"M22.64 17.232l-1.28 1.537-3-2.5 1.28-1.537 3 2.5zM3 15H1V9h2v6zM24 13h-4v-2h4v2zM22.64 6.77l-3 2.5-1.28-1.538 3-2.5 1.28 1.537z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};